import { API, setAuthToken } from '../../../config/API.js';
import { GET_LAPORAN_KEUANGAN, SET_LOADING_LAPORAN_KEUANGAN, SET_PAGINATION_LAPORAN_KEUANGAN } from '../constant.js';

export const getLaporanKeuangan = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_LAPORAN_KEUANGAN,
      payload: true,
    });
    API.get(
      `admin/relation/financial?${new URLSearchParams(params).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_LAPORAN_KEUANGAN,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_LAPORAN_KEUANGAN,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_LAPORAN_KEUANGAN,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_LAPORAN_KEUANGAN,
          payload: 0,
        });
      });
  };
};

export const addLaporanKeuangan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/relation/financial/add", params);
};

export const getDetailLaporanKeuangan = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/relation/financial/" + id);
};

export const updLaporanKeuangan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/relation/financial/edit", params);
};

export const delLaporanKeuangan = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/relation/financial/delete/" + code);
};
